<div class="row">
     <div class="col-12">
          <div class="row justify-content-between align-items-center" id="page-title">
               <h1 class="progress-header col-12 col-lg-auto">{{ 'Enroll in PSP_MAIN' | translator:'base' }}</h1>
          </div>
          <div class="row mb-2">
               <span class="col-12 col-lg-auto d-flex align-items-center small">
                    <i class="fas fa-triangle-exclamation me-2" aria-hidden="true"></i>
                    <span [innerHtml]="'Start_8-1' | translator:'base'">
                         Are you a <strong>driver</strong> looking for your own PSP record?
                    </span>
                    <a routerLink="/driver/1" (click)="scrollToTop()" name="Driver-record-request"
                         id="Driver-record-request" [title]="'Start_8-2' | translator:'base'" class="ms-1">
                         <span [innerHtml]="'Start_8-2' | translator:'base'">Access your PSP record
                              here.</span>
                    </a>
               </span>
          </div>
          <div class="row">
               <div class="col-lg-8">
                    <div class="card shadow-sm rounded-0 border-0">
                         <div class="card-body">
                              <app-complete-bar [step]="4" [totalSteps]="19"></app-complete-bar>
                              <div class="overlay" *ngIf="isVerifying">
                                   <h1 class="heading" [innerHtml]="'Verifying' | translator: 'base'">
                                        Verifying...
                                   </h1>
                                   <img />
                              </div>
                              <h2>
                                   {{ enrollmentService.newCustomer!.customerType == customerType.AH ?
                                   getTranslator('MACP46_1') : getTranslator('ISP_1') }}
                              </h2>
                              <p>
                                   <span [innerHtml]="'CompanyInfo_1' | translator:'base'">What is your company's
                                        address?</span>
                              </p>
                              <hr>
                              <div class="row gx-2">

                                   <div class="col-12 mb-3" [formGroup]="companyInfo">
                                        <label class="form-label" for="AddressLine1">
                                             <span [innerHtml]="'CompanyInfo_2' | translator:'base'">Company Address
                                                  Line 1</span>
                                             <span class="text-danger text-center ms-1"
                                                  [title]="'Required' | translator:'base'">*</span>
                                        </label>
                                        <input type="text" formControlName="addressLine1" [maxlength]="34"
                                             id="AddressLine1" name="AddressLine1" class="form-control bg-light" />
                                        <div *ngIf="addressLine1!.invalid && addressLine1!.dirty"
                                             class="help-block text-danger">
                                             <div *ngIf="addressLine1!.errors?.['required']"
                                                  [innerHTML]="'Address_required' | translator:'base'">
                                             </div>
                                             <div *ngIf="addressLine1!.errors?.['maxLength']"
                                                  [innerHTML]="'Address_max' | translator:'base'">
                                             </div>
                                             <div *ngIf="addressLine1!.errors?.['pattern']"
                                                  [innerHTML]="'AddressLineInvalid' | translator:'base'">
                                             </div>
                                        </div>
                                   </div>
                                   <div class="col-12 mb-3" [formGroup]="companyInfo">
                                        <label class="form-label" for="AddressLine2">
                                             {{ 'CompanyInfo_3' | translator:'base' }}
                                        </label>
                                        <input type="text" formControlName="addressLine2"
                                             [ngClass]="{ 'form-control': true, 'bg-light': true, 'nonRequiredMargin': true }"
                                             [maxlength]="14" id="AddressLine2" name="AddressLine2" />
                                        <div *ngIf="addressLine2!.invalid && addressLine2!.dirty"
                                             class="help-block text-danger">
                                             <div *ngIf="addressLine2!.errors?.['maxLength']"
                                                  [innerHTML]="'Address_max' | translator:'base'">
                                             </div>
                                             <div *ngIf="addressLine2!.errors?.['pattern']"
                                                  [innerHTML]="'AddressLineInvalid' | translator:'base'">
                                             </div>
                                        </div>
                                   </div>
                                   <div class="col-12 col-md-6 pe-md-2 mb-3" [formGroup]="companyInfo">
                                        <label class="form-label" for="City">
                                             {{ 'City' | translator:'base' }}<span class="text-danger text-center ms-1"
                                                  [title]="'Required' | translator:'base'">*</span>
                                        </label>
                                        <input type="text" formControlName="city"
                                             [ngClass]="{ 'form-control': true, 'bg-light': true }" [maxlength]="30"
                                             id="City" name="City" />
                                        <div *ngIf="city!.invalid && city!.dirty" class="help-block text-danger">
                                             <div *ngIf="city!.errors?.['required']"
                                                  [innerHTML]="'City_required' | translator:'base'">
                                             </div>
                                             <div *ngIf="city!.errors?.['maxLength']"
                                                  [innerHTML]="'City_max' | translator:'base'">
                                             </div>
                                             <div *ngIf="city!.errors?.['pattern']"
                                                  [innerHTML]="'City_invalid' | translator:'base'">
                                             </div>
                                        </div>
                                   </div>
                                   <div class="col-12 col-md-3 px-md-2 mb-3" [formGroup]="companyInfo">
                                        <label class="form-label" for="state">
                                             {{ enrollmentService.newCustomer!.country!.toString() === 'USA' ? 'State' :
                                             'Provence' | translator:'base' }}<span class="text-danger text-center ms-1"
                                                  [title]="'Required' | translator:'base'">*</span>
                                        </label>
                                        <select formControlName="state"
                                             [ngClass]="{ 'form-select': true, 'bg-light': true }" id="state"
                                             name="state" [required]="true">
                                             <option value="" selected></option>
                                             <option *ngFor="let c of stateList" [ngValue]="c">{{ c }}</option>
                                        </select>
                                        <div *ngIf="state!.invalid && state!.dirty" class="help-block text-danger">
                                             <div *ngIf="state!.errors?.['required']"
                                                  [innerHTML]="'City_State is required' | translator:'base'">
                                             </div>
                                        </div>
                                   </div>
                                   <div class="col-12 col-md-3 ps-md-2 mb-3" [formGroup]="companyInfo">
                                        <label class="form-label" for="PostalCode">
                                             <span [innerHTML]="'Postal Code' | translator:'base'"></span>
                                             <span class="text-danger text-center ms-1"
                                                  [title]="'Required' | translator:'base'">*</span>
                                        </label>
                                        <input size="10" [maxlength]="10" type="text" formControlName="zip"
                                             [ngClass]="{ 'form-control': true, 'bg-light': true, 'w-100': true }"
                                             id="PostalCode" name="PostalCode" />
                                        <div *ngIf="zip!.invalid && zip!.dirty" class="help-block text-danger">
                                             <div *ngIf="zip!.errors?.['required']"
                                                  [innerHTML]="'PostalCode_required' | translator:'base'">
                                             </div>
                                             <div *ngIf="zip!.errors?.['pattern']"
                                                  [innerHTML]="'PostalCode_invalid' | translator:'base'">
                                             </div>
                                        </div>

                                   </div>
                                   <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
                                        <div class="btn-group" role="group">
                                             <button [disabled]="hasErrors()" class="btn btn-primary btn-strong"
                                                  (click)="checkForExistingCustomer()"
                                                  title="{{ 'CompanyInfo' | translator:'base' }}" name="companyNext6"
                                                  id="companyNext6">
                                                  <span [innerHtml]="'Continue' | translator:'base'">Continue</span>
                                             </button>
                                        </div>
                                        <div class="btn-group" role="group">
                                             <button routerLink="/signup/5" class="btn btn-outline-primary"
                                                  title="{{ 'CompanyName' | translator:'base' }}" name="companyBack6"
                                                  id="companyBack6" (click)="scrollToTop()">
                                                  <span [innerHtml]="'Back' | translator:'base'">Back</span>
                                             </button>
                                             <button routerLink="/" tag="button" class="btn btn-light"
                                                  (click)="scrollToTop()" name="companyCancel6" id="companyCancel6"
                                                  [innerHtml]="'Cancel' | translator:'base'"
                                                  title="{{ 'Cancel' | translator:'base' }}"></button>
                                        </div>
                                   </div>
                              </div>
                         </div>

                    </div>
               </div>
               <app-progress-wizard [wizardObj]="wizardObj" [activeStep]="2"
                    [pageType]="enrollmentService.newCustomer!.customerType || '-'"
                    class="col-lg-4 sidebar d-none d-lg-block"></app-progress-wizard>
          </div>
     </div>
     <ng-template #PossibleDuplicateModal let-modal>
          <div class="modal-header">
               <h3 id="possibleDuplicateTitle" class="modal-title" slot="header"
                    [innerHtml]="'dupCustHeading' | translator:'customer'">
                    Customer Already Enrolled
               </h3>
          </div>
          <div class="modal-body">
               <div>
                    <p>
                         <span [innerHtml]="'dupCustBody1' | translator:'customer'">Our records reflect that </span>
                         {{ existingCompanyName }}
                         <span [innerHtml]="'dupCustBody2' | translator:'customer'"> located at </span>
                         {{ existingCompanyAddress }}
                         <span [innerHtml]="'dupCustBody3' | translator:'customer'"> is already enrolled in PSP. If you
                              feel this is an error, please contact Customer Support at </span>
                         <a href="tel:1-877-642-9499" title="1-877-642-9499">1-877-642-9499</a>
                         <span [innerHtml]="'dupCustBody4' | translator:'customer'"> or </span>
                         <a href="mailto:PSPhelp@tylertech.com" title="PSPhelp@tylertech.com">PSPhelp&#64;tylertech.com</a>.
                    </p>
               </div>
          </div>
          <div class="modal-footer">
               <button class="btn btn-primary" name="newCompany" id="newCompany" (click)="continueEnrollment()"
                    [innerHtml]="'Continue' | translator:'base'" [title]="'Continue' | translator:'base'">
               </button>
               <button class="btn btn-light" name="duplicateCompany" id="duplicateCompany" (click)="cancelDuplicate()"
                    [innerHtml]="'Cancel' | translator:'base'" [title]="'Cancel' | translator:'base'">
                    <span>Cancel</span>
               </button>
          </div>
     </ng-template>
     <app-spinner
          [isLoading] = isLoading
     ></app-spinner>
</div>